import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { types } from '../actions/cardsActions';
import { ReportTableModel } from '../models/ReportTableModel';

export default function cardClientsReducer(state = Immutable(initialState.reports.cardClients), action) {
  switch (action.type) {
    case types.LOAD_CARD_CLIENTS: {
      return Immutable.merge(state, {
        loading: true,
        pagedData: ReportTableModel.pageRequested(state.pagedData, action.pageNumber, action.pageSize, action.filterBy, action.sortBy),
      });
    }
    case types.LOAD_CARD_CLIENTS_SUCCESS: {
      const result = action.result;
      return Immutable.merge(state, {
        loading: false,
        pagedData: ReportTableModel.pageReady(state.pagedData, result.totalDataCount, result.data),
      });
    }
    case types.REMOVE_CLIENT_CARD_SUCCESS: {
      const cardId = action.cardId;
      return Immutable.merge(state, {
        loading: false,
        pagedData: ReportTableModel.pageReady(state.pagedData, state.pagedData.paging.totalSize, state.pagedData.records.filter(r => r.cardId !== cardId)),
      });
    }
    default:
      return state;
  }
}
